// extracted by mini-css-extract-plugin
export default {"container":"UserInvalidPage_container__w17C1","title":"UserInvalidPage_title__-VUmH","description":"UserInvalidPage_description__tzqNL"};